"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _BaseButton = _interopRequireDefault(require("../BaseButton"));

var _units = require("../../theme/units");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var StyledButton = (0, _styledComponents["default"])(_BaseButton["default"]).withConfig({
  displayName: "Button__StyledButton",
  componentId: "dkx6xg-0"
})(function (props) {
  return (0, _styledComponents.css)(["cursor:pointer;transition:0.2s ease-out;position:relative;min-width:4.5rem;display:flex;flex-direction:row;justify-content:center;align-items:center;margin:0.25rem;padding:0.5rem;width:", ";background-color:", ";border-radius:", ";outline:none;border:0;font-weight:", ";svg{", " ", " path{fill:", ";}}:active{color:", ";background-color:", ";svg path{transition:fill 0.2s ease-out;fill:", ";}}:hover{box-shadow:", ";}:focus{box-shadow:0 0 0 0.25rem ", ";}:disabled{background-color:", ";cursor:default;font-weight:", ";color:", ";span{cursor:default;}svg path{fill:", ";}}"], props.fullWidth ? 'calc(100% - 0.5rem)' : 'auto', props.active ? props.theme.color.action : props.theme.color.paper, _units.globalSizes.smallest, props.theme.font.weight.bold, props.hasIconLeft && (0, _styledComponents.css)(["margin-right 0.5rem;"]), props.hasIconRight && (0, _styledComponents.css)(["margin-left 0.5rem;"]), props.active ? props.theme.color.paper : props.theme.color.action, props.theme.color.paper, props.theme.color.action, props.theme.color.paper, props.disabled ? 'none' : "0 0 0 0.25rem ".concat(props.theme.color.hover), props.theme.color.focus, props.theme.color.paper, props.theme.font.weight.regular, props.theme.color.text, props.theme.color.text);
});
/**
 *
 * #### Blue Prism styled `Button` component

The **Button**  component renders an html `<button>` element to the dom.
It is a fixed height and width by default but can be set to 100% of its parent width by passing `true` to the `fullWidth` prop.
The **Button** can also be made togglable by setting the `toggleable ` prop to true.
Button can also accept icons, they need to be passed in as props: **iconLeft** and respectively **iconRight**.
 */

var Button = /*#__PURE__*/_react["default"].forwardRef(function Button(_ref, ref) {
  var _ref$children = _ref.children,
      children = _ref$children === void 0 ? 'click me' : _ref$children,
      _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$fullWidth = _ref.fullWidth,
      fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
      iconLeft = _ref.iconLeft,
      iconRight = _ref.iconRight,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
      _ref$toggleable = _ref.toggleable,
      toggleable = _ref$toggleable === void 0 ? false : _ref$toggleable,
      rest = _objectWithoutProperties(_ref, ["children", "active", "disabled", "fullWidth", "iconLeft", "iconRight", "onClick", "toggleable"]);

  var _useState = (0, _react.useState)(active),
      _useState2 = _slicedToArray(_useState, 2),
      isActive = _useState2[0],
      setIsActive = _useState2[1];

  var handleClick = function handleClick(event) {
    if (toggleable) setIsActive(function (isActive) {
      return !isActive;
    });
    onClick(event);
  };

  (0, _react.useEffect)(function () {
    setIsActive(active);
  }, [active, toggleable]);
  return /*#__PURE__*/_react["default"].createElement(StyledButton, _extends({
    "aria-pressed": isActive,
    disabled: disabled,
    active: isActive,
    fullWidth: fullWidth,
    onClick: handleClick,
    ref: ref,
    hasIconLeft: !!iconLeft,
    hasIconRight: !!iconRight
  }, rest), iconLeft && /*#__PURE__*/_react["default"].cloneElement(iconLeft, {
    size: 16
  }), children, iconRight && /*#__PURE__*/_react["default"].cloneElement(iconRight, {
    size: 16
  }));
});

var _default = Button;
exports["default"] = _default;